import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationBehaviorOptions, Router } from '@angular/router';
import { navPaths } from '@core/models/support.model';
import { CampagneTypologieService, GlobalDataService } from '@core/services';

@Component({
  selector: 'app-campagne-typologie-enveloppe',
  templateUrl: './campagne-typologie-enveloppe.component.html',
  styleUrls: ['./campagne-typologie-enveloppe.component.scss']
})
export class CampagneTypologieEnveloppeComponent implements OnInit {

  typologie: string = "enveloppe";
  navigationOption: NavigationBehaviorOptions = {};

  constructor(
    private router: Router,
    private readonly activatedRoute: ActivatedRoute,    
    public _GlobalDataService: GlobalDataService,
    public _CampagneTypologieService: CampagneTypologieService,
  ) {
    const routeState = this.router.getCurrentNavigation()?.extras?.state || history.state;
    const typologieFromState = routeState?.['typologie'];
    if (typologieFromState === 'autre' || typologieFromState === 'lettre' || typologieFromState === 'enveloppe') {
      this.typologie = typologieFromState;
    }
  }
  
  ngOnInit(): void {
  }

  gotoTypologieSelection(): void {
    console.log('gotoTypologieSelection');
    this._CampagneTypologieService.navigate(navPaths.selection, this.activatedRoute.parent as ActivatedRoute, this.navigationOption);
  }  

}
